import { render, staticRenderFns } from "./ArtistListNew.vue?vue&type=template&id=5079df79&scoped=true&"
import script from "./ArtistListNew.vue?vue&type=script&lang=js&"
export * from "./ArtistListNew.vue?vue&type=script&lang=js&"
import style0 from "./ArtistListNew.vue?vue&type=style&index=0&id=5079df79&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5079df79",
  null
  
)

export default component.exports